import { money, when } from "@/lib/adminApi";

const badge = {
  paid: "bg-green-100 text-green-700",
  active: "bg-green-100 text-green-700",
  pending: "bg-amber-100 text-amber-700",
  completed: "bg-green-100 text-green-700",
};

export function StatusBadge({ status }) {
  return <span className={`text-[11px] font-semibold px-2 py-0.5 rounded-full ${badge[status] || "bg-gray-100 text-gray-600"}`}>{status}</span>;
}

export function DataTable({ columns, rows, rowKey, emptyText, testId }) {
  return (
    <div className="overflow-x-auto bg-white rounded-xl border border-gold/15" data-testid={testId}>
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-[11px] uppercase tracking-widest text-gray-400 border-b border-gold/10">
            {columns.map((c) => <th key={c.key} className="px-4 py-3 font-semibold whitespace-nowrap">{c.label}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr><td colSpan={columns.length} className="px-4 py-10 text-center text-gray-400" data-testid={`${testId}-empty`}>{emptyText}</td></tr>
          ) : rows.map((r) => (
            <tr key={r[rowKey]} className="border-b border-gold/5 hover:bg-cream-light/60 align-top" data-testid={`${testId}-row`}>
              {columns.map((c) => <td key={c.key} className="px-4 py-3 text-brown-dark">{c.render ? c.render(r) : r[c.key] ?? "—"}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export const orderColumns = [
  { key: "created_at", label: "Date", render: (r) => <span className="whitespace-nowrap text-gray-500">{when(r.created_at)}</span> },
  { key: "payment_status", label: "Status", render: (r) => <StatusBadge status={r.payment_status} /> },
  { key: "items_text", label: "Items" },
  { key: "amount_total", label: "Total", render: (r) => <span className="font-semibold">{money(r.amount_total ?? r.amount)}</span> },
  { key: "shipping_cost", label: "Ship", render: (r) => (r.shipping_cost ? money(r.shipping_cost) : "Free") },
  { key: "promo_code", label: "Promo" },
  { key: "payer", label: "Customer", render: (r) => <span>{r.payer_name || "—"}<br /><span className="text-xs text-gray-400">{r.payer_email}</span></span> },
  { key: "address_text", label: "Ship To", render: (r) => <span className="text-xs">{r.address_text || "—"}</span> },
  { key: "session_id", label: "PayPal Order", render: (r) => <span className="text-xs text-gray-400 font-mono">{r.session_id}</span> },
];

export const subscriptionColumns = [
  { key: "created_at", label: "Started", render: (r) => <span className="whitespace-nowrap text-gray-500">{when(r.created_at)}</span> },
  { key: "status", label: "Status", render: (r) => <StatusBadge status={r.status} /> },
  { key: "items_text", label: "Plan" },
  { key: "amount", label: "Price", render: (r) => <span className="font-semibold">{money(r.amount)}</span> },
  { key: "payer", label: "Customer", render: (r) => <span>{r.payer_name || "—"}<br /><span className="text-xs text-gray-400">{r.payer_email}</span></span> },
  { key: "address_text", label: "Ship To", render: (r) => <span className="text-xs">{r.address_text || "—"}</span> },
  { key: "next_billing_time", label: "Next Charge", render: (r) => <span className="whitespace-nowrap text-gray-500">{when(r.next_billing_time)}</span> },
  { key: "subscription_id", label: "PayPal ID", render: (r) => <span className="text-xs text-gray-400 font-mono">{r.subscription_id}</span> },
];

export const signupColumns = [
  { key: "created_at", label: "Date", render: (r) => <span className="whitespace-nowrap text-gray-500">{when(r.created_at)}</span> },
  { key: "email", label: "Email" },
  { key: "source", label: "Source" },
];
